import React from 'react';
import { StyledSmallSectionHeader } from 'containers/AUTODashboard/Body/MyContracts/styles';
import messages from 'containers/EpargnDashboard/Body/SituationEpargn/messages';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import { SituationEpargnCard } from 'components/ItemInfoCard';
import { get } from 'lodash';
import moment from 'moment';
import { renderUnit, renderUnitTaux, currencyFormat } from 'utils/string';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import CustomCarousel from 'components/CustomCarousel';
import styled from 'styled-components';
import {
  EPARGN_PRODUCT_SCR,
  EPARGN_PRODUCT_SCR_NAME,
} from 'constants/globalConstants';

const CarousalWrapper = styled.div`
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
`;

const SituationEpargn = (props: {
  intl: IntlShape;
  setDetailsPageBreadcrumbsPath: Function;
  contractsEpargn: any[];
}) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, props)}
      </StyledSmallSectionHeader>
      <CarousalWrapper>
        <CustomCarousel
          showIndicators={
            props.contractsEpargn && props.contractsEpargn.length > 1
          }
        >
          {props.contractsEpargn &&
            props.contractsEpargn.map((item, index) => (
              <SituationEpargnCard
                wrapperPaddingRight={
                  index === props.contractsEpargn.length - 1 ? '24px' : '35px'
                }
                wrapperPaddingLeft={index === 0 ? '24px' : '35px'}
                dateValue={
                  item.infoPolice &&
                  get(item.infoPolice, 'CODE_PRODUIT') === EPARGN_PRODUCT_SCR
                    ? `${currencyFormat(
                        get(item.infoPolice, 'SCR_CAPIT_OU_RENTE_GAR'),
                      )} ${renderUnit(
                        get(item.infoPolice, 'SCR_CAPIT_OU_RENTE_GAR'),
                        reverse,
                      )}`
                    : `${currencyFormat(
                        get(item.infoPolice, 'CAPITAL_CONSTITUE_SS_PB'),
                      )} ${renderUnit(
                        get(item.infoPolice, 'CAPITAL_CONSTITUE_SS_PB'),
                        reverse,
                      )}`
                }
                product={
                  get(item.infoPolice, 'CODE_PRODUIT') === EPARGN_PRODUCT_SCR
                    ? EPARGN_PRODUCT_SCR_NAME
                    : get(item.infoPolice, 'LIBELLE_PRODUIT')
                }
                dateSituation={moment(
                  get(item.infoPolice, 'DATE_SITUATION'),
                  'YYYY-MM-DD',
                )
                  .format('DD/MM/YYYY')
                  .toString()}
                numValue={
                  get(item.infoPolice, 'TMG') +
                  '' +
                  renderUnitTaux(get(item.infoPolice, 'TMG'))
                }
                setDetailsPageBreadcrumbsPath={
                  props.setDetailsPageBreadcrumbsPath
                }
              />
            ))}
        </CustomCarousel>
      </CarousalWrapper>
    </>
  );
};

export default injectIntl(SituationEpargn);
